import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../reducers/types";
import { ActivityBook } from "./component";
import {
  getActivityDetailsProperties,
  getExperiencesShopDetails,
  getExperiencesShopPriceBreakdown,
  getOpaqueActivityToken,
  getSelectedBookableItem,
  getTravelerCountsWithMinimums,
} from "../shop/reducer";
import {
  getExperiencesShopOptionTrackingProperties,
  getRewardsAccounts,
} from "../rewards/reducer";

const mapStateToProps = (state: IStoreState) => ({
  shopDetails: getExperiencesShopDetails(state),
  priceBreakdown: getExperiencesShopPriceBreakdown(state),
  travelerCounts: getTravelerCountsWithMinimums(state),
  rewardsAccounts: getRewardsAccounts(state),
  shopOptionTrackingProperties:
    getExperiencesShopOptionTrackingProperties(state),
  activityDetailsProperties: getActivityDetailsProperties(state), // Same properties as viewed_activities_details https://hopper-jira.atlassian.net/browse/COTA-2494
  opaqueProductToken: getOpaqueActivityToken(state),
  selectedBookableItem: getSelectedBookableItem(state),
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ActivityBookConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedActivityBook = withRouter(connector(ActivityBook));
